<template>
  <a
    :href="link"
    target="_blank"
    rel="noopener noreferrer"
    class="w-full p-4 bg-neutral-100 xs:max-w-max block rounded-2xl"
  >
    <div class="w-full flex flex-col xs:flex-row gap-4 xs:gap-6 items-center">
      <div
        v-lazy-container="{ selector: 'img' }"
        class="w-full h-24 xs:w-32 rounded-md xs:rounded-lg"
      >
        <img
          :data-src="getAssetUrl(imageUrl)"
          :alt="$t('for-vets.faq.blog-post-guide-thumbnail-alt')"
          class="w-full h-full object-cover xs:object-fill rounded-md xs:rounded-lg"
        />
      </div>
      <div class="flex flex-1 items-center gap-6">
        <div class="flex-1 w-full xs:max-w-[14rem]">
          <h3 class="font-title text-lg leading-5 font-bold mb-2 text-neutral-900 line-clamp-3">
            {{ title }}
          </h3>
          <small class="text-base leading-5 text-neutral-700">
            {{ date }} • {{ readingTime }} <span class="lowercase">{{ $t('for-vets.faq-list.min-read') }}</span>
          </small>
        </div>
        <div class="w-9 h-9 rounded-full bg-grimace-800 flex justify-center items-center">
          <img
            :src="arrowSvg"
            aria-hidden="true"
            alt=""
            class="w-4 object-contain"
          />
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import { getAssetUrl } from '@/helpers/url';

export default {
  name: 'VetsterBlogGuideCard',

  props: {
    title: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    readingTime: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      arrowSvg: getAssetUrl('/images/arrows/straight-short-white-arrow.svg'),
    };
  },

  methods: {
    getAssetUrl,
  },
};
</script>
